﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";
import Select from "react-select";

import { Row, Col, Form, Modal, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { hasPermission, toast, validRoles } from "@/services/Utils";
import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";

import { customStyles } from "../species.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const SpeciesForm = ({ estates_parents, estates, categories, confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const { customer: customerConfig } = useSelector((state) => state.auth.user);

	const [isFetching, setIsFetching] = useState(true);
	const [name, setName] = useState("");
	const [description, setDescription] = useState("");
	const [customer, setCustomer] = useState("");
	const [category, setCategory] = useState("");
	const [estateParentID, setEstateParentID] = useState("");
	const [estate, setEstate] = useState([]);

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isManager = validRoles(userRoles, ["administrador", "gerente_agricola", "administrador_campo"]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		if (location.pathname.includes("configuracion")) {
			navigate("/configuracion/paso-1");
			return;
		}

		if (location.pathname.includes("mantenedores")) {
			navigate("/mantenedores/paso-1");
			return;
		}
	};

	const validSave = () => {
		if (estate && estate.length === 0) {
			toast(addToast, "Debe seleccionar al menos un campo para guardar.", "error");
			return false;
		}

		if (!category) {
			toast(addToast, "Debe seleccionar una categoría para guardar.", "error");
			return false;
		}

		if (!name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!customer && location.pathname.includes("mantenedores")) {
			addToast("Debe seleccionar un cliente para guardar.", {
				appearance: "error",
			});

			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(
				{
					slug,
					name,
					description,
					category,
					estate,
					customer,
				},
				setIsFetching,
				afterSave,
			);
		}
	};

	const emptyFields = () => {
		setName("");
		setDescription("");
		setCategory("");
		setEstate([]);
		setCustomer("");
	};

	const afterSave = () => {
		handleClose();
		addToast("Registro guardado correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/species/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setName(detail.name ? detail.name : "");
					setDescription(detail.description ? detail.description : "");
					setCustomer(detail.customer_id ? detail.customer_id : "");
					setCategory(detail.category_id ? detail.category_id : "");
					setEstateParentID(detail.estate_parent_id ? detail.estate_parent_id : "");
					setEstate(detail.estates ? detail.estates : []);
				} else {
					addToast("Ocurrió un problema al cargar el registro seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			if (estates_parents.length === 1) {
				setEstateParentID(estates_parents[0].value);
			}
			if (estates && estates.length === 1) {
				setEstate([estates[0].value]);
			}
			if (categories && categories.length === 1) {
				setCategory(categories[0].value);
			}

			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [slug, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Paso 1</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control value={name} onChange={(e) => setName(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						{!!customerConfig.use_estates_parents && (
							<Col md={12} xs={12}>
								<Form.Group className={classes.group_form}>
									<Form.Label className={classes.label}>
										{customerConfig.customer_screens.find((cs) => cs.screen_id === 38)
											? customerConfig.customer_screens.find((cs) => cs.screen_id === 38)?.name
											: "Grupos Campos"}
									</Form.Label>

									<Select
										value={estates_parents && estates_parents.filter((c) => Number(c.value) === Number(estateParentID))}
										placeholder={<div>Seleccione</div>}
										options={estates_parents ? estates_parents : []}
										onChange={(value) => {
											setEstateParentID(value ? value.value : "");
											setEstate("");
										}}
										components={{
											NoOptionsMessage,
										}}
										isClearable
									/>
								</Form.Group>
							</Col>
						)}

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>
									{customerConfig.customer_screens.find((cs) => cs.screen_id === 51)
										? customerConfig.customer_screens.find((cs) => cs.screen_id === 51)?.name
										: "Campos"}
								</Form.Label>
								<Select
									value={estates && estates.filter((et) => estate && estate.includes(et.value))}
									placeholder={<div>Seleccione </div>}
									options={estateParentID ? estates.filter((e) => e.estate_parent_id === estateParentID) : estates ? estates : []}
									onChange={(value) => {
										const newEstates = [value.value];
										setEstate(newEstates);

										if (category) {
											const cat = categories.find((c) => c.value === category);
											if (!cat || !cat.estate_ids || !cat.estate_ids.includes(value.value)) {
												setCategory("");
											}
										}
									}}
									components={{
										NoOptionsMessage,
									}}
									isDisabled={!isManager}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>
						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Categoría</Form.Label>
								<Select
									value={categories && categories.filter((c) => Number(c.value) === Number(category))}
									placeholder={<div>Seleccione</div>}
									options={categories ? categories.filter((c) => c.estate_ids && c.estate_ids.some((eid) => estate.includes(eid))) : []}
									onChange={(value) => {
										if (value) {
											setCategory(value.value);
										} else {
											setCategory("");
										}
									}}
									components={{
										NoOptionsMessage,
									}}
									isClearable
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default SpeciesForm;
